<template>
    <figure class="relative lg:absolute w-1/2 lg:w-text-block mx-auto left-0 right-0 pt-3 mb-8 lg:mb-0">
        <img class="w-56 h-auto mx-auto lg:-ml-64" :src="require(`@/assets/${imgsrc}`)" :alt="`${subtitle}`" />
        <figcaption class="w-56 h-auto mx-auto lg:-ml-64 text-center lg:text-right mt-2">{{ subtitle }}</figcaption>
        <figcaption class="w-56 h-auto mx-auto lg:-ml-64 text-center lg:text-right mt-2">{{ credits }}</figcaption>
    </figure>
</template>

<script>
export default {
    props: ['imgsrc', 'subtitle', 'credits'],
    data() {
        return {}
    },
}
</script>

<style lang="postcss" scoped></style>
